/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 2L12 17M12 17L16 13M12 17L8 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 8.00002L16.5 8V8C17.8956 8 18.5934 8.00001 19.1612 8.17225C20.4396 8.56006 21.44 9.56046 21.8278 10.8389C22 11.4067 22 12.1044 22 13.5V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22L8.4 22C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6L2 13.5C2 12.1044 2 11.4067 2.17224 10.8389C2.56004 9.56046 3.56045 8.56005 4.83884 8.17225C5.40664 8.00001 6.10442 8 7.5 8V8L8 8.00002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="8"
				width="20"
				height="14"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M16 8.00002L16.5 8V8C17.8956 8 18.5934 8.00001 19.1612 8.17225C20.4396 8.56006 21.44 9.56046 21.8278 10.8389C22 11.4067 22 12.1044 22 13.5V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22L8.4 22C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6L2 13.5C2 12.1044 2 11.4067 2.17224 10.8389C2.56004 9.56046 3.56045 8.56005 4.83884 8.17225C5.40664 8.00001 6.10443 8 7.5 8V8L8 8.00002M12 2V17M12 17L16 13M12 17L8 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V7.25H7.65C5.40979 7.25 4.28968 7.25 3.43404 7.68597C2.68139 8.06947 2.06947 8.68139 1.68597 9.43404C1.25 10.2897 1.25 11.4098 1.25 13.65L1.25 16.35C1.25 18.5902 1.25 19.7103 1.68597 20.566C2.06947 21.3186 2.68139 21.9305 3.43404 22.314C4.28969 22.75 5.40979 22.75 7.65 22.75H16.35C18.5902 22.75 19.7103 22.75 20.566 22.314C21.3186 21.9305 21.9305 21.3186 22.314 20.566C22.75 19.7103 22.75 18.5902 22.75 16.35V13.65C22.75 11.4098 22.75 10.2897 22.314 9.43404C21.9305 8.68139 21.3186 8.06947 20.566 7.68597C19.7103 7.25 18.5902 7.25 16.35 7.25H12.75V2ZM12.75 7.25H11.25L11.25 15.1893L8.53035 12.4697C8.23746 12.1768 7.76259 12.1768 7.46969 12.4697C7.1768 12.7626 7.1768 13.2374 7.46969 13.5303L11.4697 17.5303C11.6103 17.671 11.8011 17.75 12 17.75C12.1989 17.75 12.3897 17.671 12.5304 17.5303L16.5304 13.5303C16.8232 13.2374 16.8232 12.7626 16.5304 12.4697C16.2375 12.1768 15.7626 12.1768 15.4697 12.4697L12.75 15.1893V7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 8L16.5 8V8C17.8956 8 18.5933 8 19.1611 8.17224C20.4395 8.56004 21.44 9.56046 21.8278 10.8389C22 11.4067 22 12.1044 22 13.5V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H14.5H14M8 8H7.5V8C6.10444 8 5.40666 8 4.83886 8.17224C3.56046 8.56004 2.56004 9.56046 2.17224 10.8389C2 11.4067 2 12.1044 2 13.5L2 15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H9.5H10M12 2V17L8 13M14.5 14.5L16 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 8.00002L16.5 8V8C17.8956 8 18.5934 8.00001 19.1612 8.17225C20.4396 8.56006 21.44 9.56046 21.8278 10.8389C22 11.4067 22 12.1044 22 13.5V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22L8.4 22C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6L2 13.5C2 12.1044 2 11.4067 2.17224 10.8389C2.56004 9.56046 3.56045 8.56005 4.83884 8.17225C5.40664 8.00001 6.10443 8 7.5 8V8L8 8.00002M12 2V17M12 17L16 13M12 17L8 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.65 7.25C5.40979 7.25 4.28969 7.25 3.43404 7.68597C2.68139 8.06947 2.06947 8.68139 1.68597 9.43404C1.25 10.2897 1.25 11.4098 1.25 13.65L1.25 16.35C1.25 18.5902 1.25 19.7103 1.68597 20.566C2.06947 21.3186 2.68139 21.9305 3.43404 22.314C4.28969 22.75 5.40979 22.75 7.65 22.75L16.35 22.75C18.5902 22.75 19.7103 22.75 20.566 22.314C21.3186 21.9305 21.9305 21.3186 22.314 20.566C22.75 19.7103 22.75 18.5902 22.75 16.35V13.65C22.75 11.4098 22.75 10.2897 22.314 9.43404C21.9305 8.68139 21.3186 8.06947 20.566 7.68597C19.7103 7.25 18.5902 7.25 16.35 7.25L7.65 7.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V15.1893L15.4697 12.4697C15.7626 12.1768 16.2374 12.1768 16.5303 12.4697C16.8232 12.7626 16.8232 13.2374 16.5303 13.5303L12.5303 17.5303C12.3897 17.671 12.1989 17.75 12 17.75C11.8011 17.75 11.6103 17.671 11.4697 17.5303L7.46967 13.5303C7.17678 13.2374 7.17678 12.7626 7.46967 12.4697C7.76256 12.1768 8.23744 12.1768 8.53033 12.4697L11.25 15.1893L11.25 2C11.25 1.58579 11.5858 1.25 12 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
